import {validateValue} from '../helpers/validation'

// Begin action types
export const CLEAR_VOICE_TEST = 'CLEAR_VOICE_TEST'

export const FETCH_VOICE_TEST_OVERVIEW_SUCCESS = 'FETCH_VOICE_TEST_OVERVIEW_SUCCESS'

export const CLEAR_VOICE_TEST_CANDIDATES = 'CLEAR_VOICE_TEST_CANDIDATES'
export const FETCH_VOICE_TEST_CANDIDATES_SUCCESS = 'FETCH_VOICE_TEST_CANDIDATES_SUCCESS'
export const CLEAR_VOICE_TEST_CANDIDATE_SEARCH_FIELDS = 'CLEAR_VOICE_TEST_CANDIDATE_SEARCH_FIELDS'
export const VALIDATE_VOICE_TEST_CANDIDATE_SEARCH_FIELD = 'VALIDATE_VOICE_TEST_CANDIDATE_SEARCH_FIELD'

export const SET_VOICE_TEST_CRITERIA_DROPDOWN_OPTIONS = 'SET_VOICE_TEST_CRITERIA_DROPDOWN_OPTIONS'
export const SET_VOICE_TEST_CRITERIA_CHECKBOX_VALUE = 'SET_VOICE_TEST_CRITERIA_CHECKBOX_VALUE'
export const VALIDATE_VOICE_TEST_CRITERIA_DIRECTOR_FIELD = 'VALIDATE_VOICE_TEST_CRITERIA_DIRECTOR_FIELD'
export const CLEAR_VOICE_TEST_CRITERIA_DIRECTOR_FIELDS = 'CLEAR_VOICE_TEST_CRITERIA_DIRECTOR_FIELDS'
export const VALIDATE_VOICE_TEST_CRITERIA_TRANSLATOR_FIELD = 'VALIDATE_VOICE_TEST_CRITERIA_TRANSLATOR_FIELD'
export const CLEAR_VOICE_TEST_CRITERIA_TRANSLATOR_FIELDS = 'CLEAR_VOICE_TEST_CRITERIA_TRANSLATOR_FIELDS'
export const VALIDATE_VOICE_TEST_CRITERIA_VOICEACTOR_FIELD = 'VALIDATE_VOICE_TEST_CRITERIA_VOICEACTOR_FIELD'
export const CLEAR_VOICE_TEST_CRITERIA_VOICEACTOR_FIELDS = 'CLEAR_VOICE_TEST_CRITERIA_VOICEACTOR_FIELDS'
export const VALIDATE_VOICE_TEST_CRITERIA_SINGER_FIELD = 'VALIDATE_VOICE_TEST_CRITERIA_SINGER_FIELD'
export const CLEAR_VOICE_TEST_CRITERIA_SINGER_FIELDS = 'CLEAR_VOICE_TEST_CRITERIA_SINGER_FIELDS'
export const VALIDATE_VOICE_TEST_CRITERIA_ADAPTOR_FIELD = 'VALIDATE_VOICE_TEST_CRITERIA_ADAPTOR_FIELD'
export const CLEAR_VOICE_TEST_CRITERIA_ADAPTOR_FIELDS = 'CLEAR_VOICE_TEST_CRITERIA_ADAPTOR_FIELDS'
export const VALIDATE_VOICE_TEST_CRITERIA_LYRICIST_FIELD = 'VALIDATE_VOICE_TEST_CRITERIA_LYRICIST_FIELD'
export const CLEAR_VOICE_TEST_CRITERIA_LYRICIST_FIELDS = 'CLEAR_VOICE_TEST_CRITERIA_LYRICIST_FIELDS'
export const VALIDATE_VOICE_TEST_CRITERIA_EDITOR_FIELD = 'VALIDATE_VOICE_TEST_CRITERIA_EDITOR_FIELD'
export const CLEAR_VOICE_TEST_CRITERIA_EDITOR_FIELDS = 'CLEAR_VOICE_TEST_CRITERIA_EDITOR_FIELDS'
export const VALIDATE_VOICE_TEST_CRITERIA_SOUNDENGINEER_FIELD = 'VALIDATE_VOICE_TEST_CRITERIA_SOUNDENGINEER_FIELD'
export const CLEAR_VOICE_TEST_CRITERIA_SOUNDENGINEER_FIELDS = 'CLEAR_VOICE_TEST_CRITERIA_SOUNDENGINEER_FIELDS'
export const VALIDATE_VOICE_TEST_CRITERIA_BOOKER_FIELD = 'VALIDATE_VOICE_TEST_CRITERIA_BOOKER_FIELD'
export const CLEAR_VOICE_TEST_CRITERIA_BOOKER_FIELDS = 'CLEAR_VOICE_TEST_CRITERIA_BOOKER_FIELDS'
export const FETCH_VOICE_TEST_SKILLVENDORS_BY_CRITERIA_SUCCESS = 'FETCH_VOICE_TEST_SKILLVENDORS_BY_CRITERIA_SUCCESS'
export const CLEAR_VOICE_TEST_SKILLVENDORS_BY_CRITERIA = 'CLEAR_VOICE_TEST_SKILLVENDORS_BY_CRITERIA'

export const FETCH_VOICE_TEST_ACTIVATE_DATA_SUCCESS = 'FETCH_VOICE_TEST_ACTIVATE_DATA_SUCCESS'
export const VALIDATE_VOICE_TEST_ACTIVATE_FIELD = 'VALIDATE_VOICE_TEST_ACTIVATE_FIELD'
export const VALIDATE_VOICE_TEST_ACTIVATE_WORK_AMOUNT_UNIT_FIELD = 'VALIDATE_VOICE_TEST_ACTIVATE_WORK_AMOUNT_UNIT_FIELD'
export const SUBMIT_VOICE_TEST_ACTIVATE_FIELDS = 'SUBMIT_VOICE_TEST_ACTIVATE_FIELDS'
export const CLEAR_VOICE_TEST_ACTIVATE_FIELDS = 'CLEAR_VOICE_TEST_ACTIVATE_FIELDS'
export const CLEAR_VOICE_TEST_ACTIVATE_FIELD = 'CLEAR_VOICE_TEST_ACTIVATE_FIELD'
// End action types

export const clearVoiceTest = () => ({
  type: CLEAR_VOICE_TEST
});

export const fetchVoiceTestOverviewSuccess = (overview) => ({
  type: FETCH_VOICE_TEST_OVERVIEW_SUCCESS,
  overview
});

export const clearVoiceTestCandidates = () => ({
  type: CLEAR_VOICE_TEST_CANDIDATES
});
export const fetchVoiceTestCandidatesSuccess = (candidates) => ({
  type: FETCH_VOICE_TEST_CANDIDATES_SUCCESS,
  candidates
});
export const clearVoiceTestCandidateSearchFields = () => ({
  type: CLEAR_VOICE_TEST_CANDIDATE_SEARCH_FIELDS
});
export const validateVoiceTestCandidateSearchField = (value, field) => {
  field = validateValue(value, field);
  return {
    type: VALIDATE_VOICE_TEST_CANDIDATE_SEARCH_FIELD,
    field
  }
}

export const setVoiceTestCriteriaDropdownOptions = (skillLevels, cities, voiceGenders, liveActionVoiceGenders, animationVoiceGenders, nativeLanguages, languages, productionContentOwners,
   ageFromList, ageToList, productionExperienceList, country, region, ethnicity, identity, voiceAgeRangeList, voiceTypeList, remoteRecordingListVoiceActor,
   remoteRecordingDirector, voiceActorStudio, voiceActorClient,voiceActorSchool, skillTypes, productionCast, vacancyCast, externalExperienceCast,
 bookerStudio, voiceAgeRangeListSinger, vocalRangeListSinger, readingMusicNoteListSinger, singerStudio, singerClient, singerSchool,
directorStudio, directorClient, directorSchool, numberOfSongsWrittenRangeListLyricist, universityDegreeListLyricist, lyricistStudio, lyricistClient,
remoteRecordingListLyricist, numberOfTranslationsRangeListTranslator, universityDegreeListTranslator, translatorStudio, translatorClient, editorStudio,
 editorClient, editorSchool, remoteRecordingEditor, numberOfAdaptionsRangeListAdaptor, universityDegreeListAdaptor, adaptorStudio, adaptorClient,
 soundEngineerStudio, soundEngineerClient, soundEngineerSchool, remoteRecordingListSoundEngineer, directorAppAccess, remoteRecordingListSinger,
languageAccentList, unionListVoiceActor, unionListSinger) => ({
  type: SET_VOICE_TEST_CRITERIA_DROPDOWN_OPTIONS,
  skillLevels,
  cities,
  voiceGenders,
  liveActionVoiceGenders,
  animationVoiceGenders,
  nativeLanguages,
  languages,
  productionContentOwners,
  ageFromList,
  ageToList,
  productionExperienceList,
  country,
  region,
  ethnicity,
  identity,
  voiceAgeRangeList,
  voiceTypeList,
  remoteRecordingListVoiceActor,
  remoteRecordingDirector,
  voiceActorStudio,
  voiceActorClient,
  voiceActorSchool,
  skillTypes,
  productionCast,
  vacancyCast,
  externalExperienceCast,
  bookerStudio,
  voiceAgeRangeListSinger,
  vocalRangeListSinger,
  readingMusicNoteListSinger,
  singerStudio,
  singerClient,
  singerSchool,
  directorStudio,
  directorClient,
  directorSchool,
  numberOfSongsWrittenRangeListLyricist,
  universityDegreeListLyricist,
  lyricistStudio,
  lyricistClient,
  remoteRecordingListLyricist,
  numberOfTranslationsRangeListTranslator,
  universityDegreeListTranslator,
  translatorStudio,
  translatorClient,
  editorStudio,
  editorClient,
  editorSchool,
  remoteRecordingEditor,
  numberOfAdaptionsRangeListAdaptor,
  universityDegreeListAdaptor,
  adaptorStudio,
  adaptorClient,
  soundEngineerStudio,
  soundEngineerClient,
  soundEngineerSchool,
  remoteRecordingListSoundEngineer,
  directorAppAccess,
  remoteRecordingListSinger,
  languageAccentList,
  unionListVoiceActor,
  unionListSinger
});
export const setVoiceTestCriteriaCheckboxValue = (knownTalent, doNotUse, skillVendorStatus, liveActionVoiceGenderMale,liveActionVoiceGenderFemale, voiceActorTheatricalExperience,
voiceActorTVExperience,voiceActorVideoGamesExperience,voiceActorPromoOrCommercialsExperience,voiceActorAnimationMaleVoiceGender,voiceActorAnimationFemaleVoiceGender,
voiceActorLiveActionExperience,voiceActorAnimationExperience,voiceActorDubbingExperience,voiceActorAudiobooksExperience, voiceActorVoiceOverExperience,
voiceActorRadioExperience,voiceActorTheatreActorExperience,voiceActorMovieActorExperience,voiceActorAudioDescriptionExperience, bookerTheatricalExperience,
bookerTVExperience, bookerInteractiveExperience, singerMaleVoiceGender, singerFemaleVoiceGender,singerDubbingExperience,singerStageExperience,singerTheatreExperience,
singerTalentShowExperience,  directorTheatricalExperience, directorTVExperience, directorGamesExperience, directorPromoOrCommercialsExperience,
directorLiveActionExperience, directorAnimationExperience, directorDubbingDirectorExperience, directorVoiceOverDirectorExperience, directorSongDirectorExperience,
directorDubbingActorExperience, directorStageDirectorExperience, directorMovieDirectorExperience, directorAudioDescriptionExperience, lyricistMusicalExperience,
lyricistTheatreExperience, lyricistPromoCommercialsExperience, lyricistExperience, lyricistDubbingExperience, lyricistMusicianExperience,
translatorTheatricalExperience, translatorTVExperience, translatorGamesExperience, translatorPromoOrCommercialsExperience, translatorLiveActionExperience,
translatorAnimationExperience, translatorSubtitlesExperience, translatorDubbingExperience, translatorVoiceOverExperience, translatorGamingExperience,
translatorAudioDescriptionExperience,translatorHOHSDHCCExperience, editorDubbingExperience, editorVoiceOverExperience, editorSongsExperience, editorProToolsExperience,
editorDolby51Experience, editorAtmosExperience, editorFoleyExperience, editorRecordingEditingExperience, editorDialogueEditingExperience, editorMusicAndEffectsExperience,
editorMixEditingExperience, editorPreparingTakesExperience, editorAudioDescriptionExperience, adaptorTheatricalExperience,adaptorTVExperience, adaptorGamesExperience,
adaptorPromoOrCommercialsExperience, adaptorLiveActionExperience, adaptorAnimationExperience, adaptorAdaptorExperience, adaptorDubbingDirectorExperience,
adaptorTranslatorExperience, adaptorVoiceActorExperience, adaptorAudioDescriptionExperience, soundEngineerDubbingExperience, soundEngineerVoiceOverExperience, soundEngineerSongsExperience,
soundEngineerProToolsExperience,soundEngineerDolby51Experience,soundEngineerAtmosExperience,soundEngineerFoleyExperience,soundEngineerDialogueRecordingExperience,
soundEngineerSongRecordingExperience,soundEngineerDialogueMixingExperience,soundEngineerSongMixingExperience,soundEngineerAudioDescriptionMixingExperience,
singerGenderNeutralVoice, voiceActorGenderNeutralVoice ) => ({
  type: SET_VOICE_TEST_CRITERIA_CHECKBOX_VALUE,
  knownTalent,
  doNotUse,
  skillVendorStatus,
  liveActionVoiceGenderMale,
  liveActionVoiceGenderFemale,
  voiceActorTheatricalExperience,
  voiceActorTVExperience,
  voiceActorVideoGamesExperience,
  voiceActorPromoOrCommercialsExperience,
  voiceActorAnimationMaleVoiceGender,
  voiceActorAnimationFemaleVoiceGender,
  voiceActorLiveActionExperience,
  voiceActorAnimationExperience,
  voiceActorDubbingExperience,
  voiceActorAudiobooksExperience,
  voiceActorVoiceOverExperience,
  voiceActorRadioExperience,
  voiceActorTheatreActorExperience,
  voiceActorMovieActorExperience,
  voiceActorAudioDescriptionExperience,
  bookerTheatricalExperience,
  bookerTVExperience,
  bookerInteractiveExperience,
  singerMaleVoiceGender,
  singerFemaleVoiceGender,
  singerDubbingExperience,
  singerStageExperience,
  singerTheatreExperience,
  singerTalentShowExperience,
  directorTheatricalExperience,
  directorTVExperience,
  directorGamesExperience,
  directorPromoOrCommercialsExperience,
  directorLiveActionExperience,
  directorAnimationExperience,
  directorDubbingDirectorExperience,
  directorVoiceOverDirectorExperience,
  directorSongDirectorExperience,
  directorDubbingActorExperience,
  directorStageDirectorExperience,
  directorMovieDirectorExperience,
  directorAudioDescriptionExperience,
  lyricistMusicalExperience,
  lyricistTheatreExperience,
  lyricistPromoCommercialsExperience,
  lyricistExperience,
  lyricistDubbingExperience,
  lyricistMusicianExperience,
  translatorTheatricalExperience,
  translatorTVExperience,
  translatorGamesExperience,
  translatorPromoOrCommercialsExperience,
  translatorLiveActionExperience,
  translatorAnimationExperience,
  translatorSubtitlesExperience,
  translatorDubbingExperience,
  translatorVoiceOverExperience,
  translatorGamingExperience,
  translatorAudioDescriptionExperience,
  translatorHOHSDHCCExperience,
  editorDubbingExperience,
  editorVoiceOverExperience,
  editorSongsExperience,
  editorProToolsExperience,
  editorDolby51Experience,
  editorAtmosExperience,
  editorFoleyExperience,
  editorRecordingEditingExperience,
  editorDialogueEditingExperience,
  editorMusicAndEffectsExperience,
  editorMixEditingExperience,
  editorPreparingTakesExperience,
  editorAudioDescriptionExperience,
  adaptorTheatricalExperience,
  adaptorTVExperience,
  adaptorGamesExperience,
  adaptorPromoOrCommercialsExperience,
  adaptorLiveActionExperience,
  adaptorAnimationExperience,
  adaptorAdaptorExperience,
  adaptorDubbingDirectorExperience,
  adaptorTranslatorExperience,
  adaptorVoiceActorExperience,
  adaptorAudioDescriptionExperience,
  soundEngineerDubbingExperience,
  soundEngineerVoiceOverExperience,
  soundEngineerSongsExperience,
  soundEngineerProToolsExperience,
  soundEngineerDolby51Experience,
  soundEngineerAtmosExperience,
  soundEngineerFoleyExperience,
  soundEngineerDialogueRecordingExperience,
  soundEngineerSongRecordingExperience,
  soundEngineerDialogueMixingExperience,
  soundEngineerSongMixingExperience,
  soundEngineerAudioDescriptionMixingExperience,
  singerGenderNeutralVoice,
  voiceActorGenderNeutralVoice
});
export const clearVoiceTestCriteriaDirectorFields = () => ({
  type: CLEAR_VOICE_TEST_CRITERIA_DIRECTOR_FIELDS
});
export const validateVoiceTestCriteriaDirectorField = (value, field) => {
  field = validateValue(value, field);
  return {
    type: VALIDATE_VOICE_TEST_CRITERIA_DIRECTOR_FIELD,
    field
  }
}
export const clearVoiceTestCriteriaTranslatorFields = () => ({
  type: CLEAR_VOICE_TEST_CRITERIA_TRANSLATOR_FIELDS
});
export const validateVoiceTestCriteriaTranslatorField = (value, field) => {
  field = validateValue(value, field);
  return {
    type: VALIDATE_VOICE_TEST_CRITERIA_TRANSLATOR_FIELD,
    field
  }
}
export const clearVoiceTestCriteriaVoiceActorFields = () => ({
  type: CLEAR_VOICE_TEST_CRITERIA_VOICEACTOR_FIELDS
});
export const validateVoiceTestCriteriaVoiceActorField = (value, field) => {
  field = validateValue(value, field);
  return {
    type: VALIDATE_VOICE_TEST_CRITERIA_VOICEACTOR_FIELD,
    field
  }
}
export const clearVoiceTestCriteriaSingerFields = () => ({
  type: CLEAR_VOICE_TEST_CRITERIA_SINGER_FIELDS
});
export const validateVoiceTestCriteriaSingerField = (value, field) => {
  field = validateValue(value, field);
  return {
    type: VALIDATE_VOICE_TEST_CRITERIA_SINGER_FIELD,
    field
  }
}
export const clearVoiceTestCriteriaAdaptorFields = () => ({
  type: CLEAR_VOICE_TEST_CRITERIA_ADAPTOR_FIELDS
});
export const validateVoiceTestCriteriaAdaptorField = (value, field) => {
  field = validateValue(value, field);
  return {
    type: VALIDATE_VOICE_TEST_CRITERIA_ADAPTOR_FIELD,
    field
  }
}
export const clearVoiceTestCriteriaLyricistFields = () => ({
  type: CLEAR_VOICE_TEST_CRITERIA_LYRICIST_FIELDS
});
export const validateVoiceTestCriteriaLyricistField = (value, field) => {
  field = validateValue(value, field);
  return {
    type: VALIDATE_VOICE_TEST_CRITERIA_LYRICIST_FIELD,
    field
  }
}
export const clearVoiceTestCriteriaEditorFields = () => ({
  type: CLEAR_VOICE_TEST_CRITERIA_EDITOR_FIELDS
});
export const validateVoiceTestCriteriaEditorField = (value, field) => {
  field = validateValue(value, field);
  return {
    type: VALIDATE_VOICE_TEST_CRITERIA_EDITOR_FIELD,
    field
  }
}
export const clearVoiceTestCriteriaSoundEngineerFields = () => ({
  type: CLEAR_VOICE_TEST_CRITERIA_SOUNDENGINEER_FIELDS
});
export const validateVoiceTestCriteriaSoundEngineerField = (value, field) => {
  field = validateValue(value, field);
  return {
    type: VALIDATE_VOICE_TEST_CRITERIA_SOUNDENGINEER_FIELD,
    field
  }
}
export const clearVoiceTestCriteriaBookerFields = () => ({
  type: CLEAR_VOICE_TEST_CRITERIA_BOOKER_FIELDS
});
export const validateVoiceTestCriteriaBookerField = (value, field) => {
  field = validateValue(value, field);
  return {
    type: VALIDATE_VOICE_TEST_CRITERIA_BOOKER_FIELD,
    field
  }
}
export const fetchVoiceTestSkillVendorsByCriteriaSuccess = (skillVendorsByCriteria) => ({
  type: FETCH_VOICE_TEST_SKILLVENDORS_BY_CRITERIA_SUCCESS,
  skillVendorsByCriteria
});
export const clearVoiceTestSkillVendorsByCriteria = () => ({
  type: CLEAR_VOICE_TEST_SKILLVENDORS_BY_CRITERIA
});

export const fetchVoiceTestActivateDataSuccess = (data, descriptionRequired) => ({
  type: FETCH_VOICE_TEST_ACTIVATE_DATA_SUCCESS,
  data,
  descriptionRequired
});
export const validateVoiceTestActivateField = (value, field) => {
  field = validateValue(value, field);
  return {
    type: VALIDATE_VOICE_TEST_ACTIVATE_FIELD,
    field
  }
}
export const validateVoiceTestActivateWorkAmountUnitField = (value, field) => {
  field = validateValue(value, field);
  return {
    type: VALIDATE_VOICE_TEST_ACTIVATE_WORK_AMOUNT_UNIT_FIELD,
    field
  }
}
export const submitVoiceTestActivateFields = (fields) => {
  return {
    type: SUBMIT_VOICE_TEST_ACTIVATE_FIELDS,
    fields
  }
}
export const clearVoiceTestActivateFields = (fields) => {
  return {
    type: CLEAR_VOICE_TEST_ACTIVATE_FIELDS
  }
}
export const clearVoiceTestActivateField = (fieldName) => {
  return {
    type: CLEAR_VOICE_TEST_ACTIVATE_FIELD,
    fieldName
  }
}
